import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Text, TextVariant } from '@naf/text';
import { Label, Select } from '@naf/input';
import { Close } from '@styled-icons/material/Close';
import useSelector from '@redux/typedHooks';
import { actions as idpCountriesAction } from '@redux/modules/idpCountries';
import * as S from './IdpCountriesList.styles';

export const IdpCountriesListBlock = () => {
  const dispatch = useDispatch();
  const [didFetchCountries, setDidFetchCountries] = useState<boolean>(false);
  const countries = useSelector((state) => state.idpCountries.data);
  const options = countries && countries.map((country) => ({ label: country.countryName, value: country.countryName }));
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);

  const selectCountry = (countryList: typeof countries, value: string) =>
    countryList.find((country) => country.countryName === value);

  useEffect(() => {
    if (!didFetchCountries) {
      dispatch(idpCountriesAction.getIdpCountries.request(undefined, undefined));
      setDidFetchCountries(true);
    }
  }, [didFetchCountries, dispatch]);

  const handleRemoveCountry = (country: string) => {
    setSelectedCountries(selectedCountries.filter((countryName) => countryName !== country));
  };

  if (options) {
    return (
      <S.Wrapper>
        <Label>Legg til land</Label>
        <Select
          options={options}
          placeholder="Velg land"
          handleSelect={(option: Record<string, string>) => setSelectedCountries([...selectedCountries, option.label])}
          maxLines={6}
        />
        {countries && selectedCountries && selectedCountries.length > 0 && (
          <S.AdditionalInfo>
            {selectedCountries.map(
              (country) =>
                selectCountry(countries, country) && (
                  <S.CountryWrapper key={country}>
                    <S.TextWrapper>
                      <Text variant={TextVariant.ArticleTextHeader}>{country}</Text>
                      <Text>{selectCountry(countries, country)?.additionalInfo}</Text>
                    </S.TextWrapper>
                    <S.CloseButton onClick={() => handleRemoveCountry(country)}>
                      <Close size={18} />
                    </S.CloseButton>
                  </S.CountryWrapper>
                ),
            )}
          </S.AdditionalInfo>
        )}
      </S.Wrapper>
    );
  }
  return null;
};
